<template>
    <div>
        <el-button type="primary" size="mini" @click="getTableData">查询用户</el-button>
        <el-dialog
            title="查询用户"
            :visible.sync="showdialog"
            width="900px"
            append-to-body>

            <div class="base-warp">
                <div class="head">
                    <el-form label-width="80px" :inline="true" size="mini">
                        <el-form-item label="用户手机">
                            <el-input v-model="telephone"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="search">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tabledata" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column label="头像" align="center">
                            <template slot-scope="s">
                                <el-popover
                                    placement="left"
                                    width="200"
                                    trigger="hover">
                                    <el-image class="ltpic" :src="s.row.ltpic" fit="scale-down"></el-image>
                                    <el-avatar class="avatar" slot="reference" icon="el-icon-user-solid" size="large" shape="circle" :src="s.row.ltpic" fit="fill"></el-avatar>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="uname" label="姓名" align="center"></el-table-column>
                        <el-table-column prop="telephone" label="电话" align="center"></el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="s">
                                <el-button type="primary" size="mini" @click="relevance(s.row)" plain>关联</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    name: 'MemberList',
    data() {
        return {
            showdialog: false,
            pageNo: 1,
            pagesize: 6,
            total: 0,
            telephone: '',
            tabledata: [],
        }
    },
    methods: {
        relevance(row) {
            this.$emit('getMember', row);
            this.showdialog = false;
        },
        getTableData() {
            this.showdialog  = true;
            var params = {
                telephone: this.telephone,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            }
            this.$api.getMember(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
        search() {
            this.pageNo = 1;
            this.getTableData();
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
.ltpic{
    width: 200px;
    height: 200px;
}
</style>